import script from "./TheSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./TheSwitcher.vue?vue&type=style&index=0&id=e5706fb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5706fb0"]])

export default __exports__